import AdministrationChildren from "./administration/AdministrationTabChildren";
import AdminProfileChildren from "./administration/AdministrationProfileChildren";

const AdminDashboard = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-admin/AdminDashboard.vue");
const AdminSessionsGroup = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/session/AdminSessionsGroup.vue"
  );
const Administration = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/Administration.vue"
  );
const AdminProfile = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-admin/AdminProfile.vue");

export default [
  {
    path: "",
    redirect: { name: "admin-dashboard" },
  },
  {
    path: "dashboard",
    name: "admin-dashboard",
    component: AdminDashboard,
  },
  {
    path: "sessionsGroup",
    name: "admin-sessionGroups",
    component: AdminSessionsGroup,
  },
  {
    path: "administration",
    name: "admin-administration",
    children: AdministrationChildren,
    component: Administration,
    redirect: { name: "admin-domains" },
  },
  {
    path: "profile",
    name: "admin-profile",
    children: AdminProfileChildren,
    component: AdminProfile,
  },
];
